import React, { useState } from 'react';
import { Dialog, DialogTitle, ListItem, ListItemText } from '@material-ui/core';
import { FixedSizeList } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import { reqCustomers, searchCustomers } from './api';
import SearchInputBox from '../common/components/SearchInputBox';

// 한 번에 요청할 item count
const PER_PAGE = 300;

const CustomerListDialog = ({ open, onClose, onSelect }) => {
  const [items, setItems] = useState([]);
  const [itemCount, setItemCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [searchWord, setSearchWord] = useState('');

  const isItemLoaded = (index) => {
    return items.length === itemCount || index < items.length;
  };

  const loadMore = async (startIndex, stopIndex) => {
    if (loading || startIndex >= itemCount) return;

    try {
      setLoading(true);

      // load next page
      const nextPage = Math.ceil(items.length / PER_PAGE) + 1;
      const { total, data } = await reqCustomers(nextPage, PER_PAGE);

      // update items, itemCount
      setItems(items.concat(data));
      setItemCount(total);

      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      setError(err);
    }
  };

  const handleEnter = () => {
    // initialize
    setItems([]);
    setItemCount(1);
  };

  const handleClick = (index) => {
    onSelect({
      id: items[index].id,
      name: items[index].name,
    });
  };

  const pressEnter = async (word) => {
    try {
      setLoading(true);
      const { total, data } = await searchCustomers(word);

      // update items, itemCount
      setItems(data);
      setItemCount(total);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  const clickClear = async () => {
    try {
      setLoading(true);
      const { total, data } = await reqCustomers(1, PER_PAGE);

      // update items, itemCount
      setItems(data);
      setItemCount(total);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onEnter={handleEnter}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">고객사 선택</DialogTitle>

      <SearchInputBox onPressEnter={pressEnter} onClickClear={clickClear} />

      <InfiniteLoader
        isItemLoaded={isItemLoaded}
        loadMoreItems={loadMore}
        itemCount={itemCount}
      >
        {({ onItemsRendered, ref }) => (
          <FixedSizeList
            height={800}
            width={400}
            itemSize={46}
            itemCount={itemCount}
            onItemsRendered={onItemsRendered}
            ref={ref}
          >
            {({ index, style }) => (
              <ListItem
                button
                style={style}
                key={index}
                onClick={() => handleClick(index)}
              >
                <ListItemText
                  primary={
                    isItemLoaded(index) ? items[index].name : 'loading ...'
                  }
                />
              </ListItem>
            )}
          </FixedSizeList>
        )}
      </InfiniteLoader>
    </Dialog>
  );
};

export default CustomerListDialog;
